import { NgClass} from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { PaymentData } from '../../../content/interfaces/payment/payment-data';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsCustomIconComponent } from '../sps-custom-icon/sps-custom-icon.component';

@Component({
  selector: 'sps-payment-type-list-item',
  imports: [
    NgClass,
    SpsCustomIconComponent,
  ],
  templateUrl: './sps-payment-type-list-item.component.html'
})
export class SpsPaymentTypeListItemComponent {

  @Input() paymentListItem: PaymentData;
  @Output() itemClicked = new EventEmitter<PaymentData>();

  i18n = inject(I18nService);

}
